export default {
  fromGerenteRelacionamentoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  toGerenteRelacionamentoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  nomeAssociado: {
    value: '',
    required: false,
    state: null
  },
  isProdutorRural: {
    value: null,
    required: false,
    state: null
  },
  tipoPessoa: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/movimentacoes/changeMassGerenteRelacionamento/link-form.js